import ConfirmYourActivityModal from './confirmYourActivityModal/confirmYourActivityModal';
import SessionTimedOutModal from './sessionTimedOutModal/sessionTimedOutModal';
import { useDeactiveTimeTracking } from './useDeactiveTimeTracking';

export interface DeactiveTimeTrackingProps {
  isLoginWithBiocarePortal: boolean;
  handleOnlySignOutBiocarePortal: () => void;
  handleRedirectToBiocarePortal: () => void;
}

const DeactiveTimeTracking = ({
  isLoginWithBiocarePortal,
  handleOnlySignOutBiocarePortal,
  handleRedirectToBiocarePortal,
}: DeactiveTimeTrackingProps) => {
  const {
    state,
    confirmYourActivityModalRef,
    handleConfirmYourActivityModal,
    handleSessionTimedOutModalDisplay,
    handleGotItClick,
  } = useDeactiveTimeTracking({
    isLoginWithBiocarePortal,
    handleOnlySignOutBiocarePortal,
    handleRedirectToBiocarePortal,
  });

  return (
    <>
      <ConfirmYourActivityModal
        ref={confirmYourActivityModalRef}
        open={state.openConfirmYourActivityModal}
        handleConfirmClick={handleConfirmYourActivityModal}
        handleSessionTimedOutModalDisplay={handleSessionTimedOutModalDisplay}
        loading={state.isConfirmingYourActivity}
      />
      <SessionTimedOutModal
        open={state.openSessionTimedOutModal}
        loading={state.isGottingIt}
        handleGotItClick={handleGotItClick}
      />
    </>
  );
};

export default DeactiveTimeTracking;
